import React from 'react';
import styled from '@emotion/styled';
import { cx } from '@emotion/css';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
import { ComponentStyle, ProductListItem } from '../../types/types';
const { mqBreakpoints, pxToRem } = StyleLibrary;

import { PrimaryButton } from '../shared/Buttons';

const TagsContainer = styled.div({
  paddingBottom: pxToRem(0),
  marginBottom: 0,

  // button overrides to make the tags buttons
  button: {
    backgroundColor: 'var(--color-midnight-blue-light)',
    fontFamily: 'Inter',
    fontSize: pxToRem(12),
    marginBottom: 0,
    padding: pxToRem(8),
    textTransform: 'uppercase',
    width: '100%',
    '&:hover': {
      backgroundColor: 'var(--color-lime-darker)',
    },
  },

  [mqBreakpoints.desktop]: {
    button: {
      fontSize: pxToRem(16),
      marginBottom: 0, //pxToRem(12),
      padding: `${pxToRem(12)} ${pxToRem(16)}`,
      width: 'auto',
    },
  },
});

const Ul = styled.ul({
  display: 'flex',
  flexWrap: 'wrap',
  gap: `${pxToRem(12)} ${pxToRem(8)}`,
  paddingBottom: 0,

  [mqBreakpoints.desktop]: {
    gap: pxToRem(24),
    paddingBottom: pxToRem(24),
  },
});

const Li = styled.li({
  listStyleType: 'none',
  width: pxToRem(96),

  [mqBreakpoints.desktop]: {
    marginBottom: 0,
    width: 'auto',
  },

  '&.A': {
    button: {
      backgroundColor: 'var(--color-dark-tint)',
      '&:hover': {
        backgroundColor: 'var(--color-lime-darker)',
      },
    },
  },

  '&.selected': {
    button: {
      backgroundColor: 'var(--color-secondary)',
      color: 'var(--color-dark)',
    },
  },
});

type Props = {
  style: ComponentStyle;
  tileItems: ProductListItem[];
  filter: string;
  setFilter: (string) => void;
};

const extractTags = items => {
  if (!items.length) return [];

  return items.reduce((tags, item) => {
    const category = item?.product?.metadata?.category;
    if (category && !tags.includes(category)) {
      tags.push(category);
    }
    return tags;
  }, []);
};

const TilesTags: React.FC<Props> = ({ style, tileItems, filter, setFilter }) => {
  const tags = ['all'].concat(extractTags(tileItems).sort());
  return (
    <TagsContainer data-testid='mp-tiles-tags'>
      <Ul className='unstyled'>
        {tags?.map(tag => {
          return (
            <Li key={tag} className={cx({ selected: tag === filter }, style)}>
              <PrimaryButton onClick={() => setFilter(tag)}>{tag}</PrimaryButton>
            </Li>
          );
        })}
      </Ul>
    </TagsContainer>
  );
};

export default TilesTags;
